export default __webpack_public_path__ + "static/media/portfolio-wilo-5.3bc41f71.jpg";